import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import * as moment from "moment";
import _ from 'lodash';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { NavController, AlertController } from 'ionic-angular';
import { ProgramDoctorsAddPage } from '../../pages/program-doctors-add/program-doctors-add';
import { DoctorProvider } from '../../providers/doctor/doctor';
import { PatientProvider } from '../../providers/patient/patient';
import { ClinicProvider } from '../../providers/clinic/clinic';

@Component({
  selector: 'patient-physician',
  templateUrl: 'patient-physician.html'
})
export class PatientPhysicianComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_id: string;
  program_name: string;
  patient: any;
  exportjson: any;
  doc: any;
  inst: any;
  isLoading: boolean;
  doctors: any;
  addeditDoctorForm: FormGroup;
  panelStatus: false;
  user: any;
  doctor: any;
  doctor2: any;
  doctor3: any;
  clinic: any;
  clinic2: any;
  clinic3: any;

  doctor_specialnotes: string;
  doctor2_specialnotes: string;
  doctor3_specialnotes: string;
  doctor4_specialnotes: string;
  doctor5_specialnotes: string;
  doctor6_specialnotes: string;

  private _program_id = new BehaviorSubject<any>([]);
  private _program_name = new BehaviorSubject<any>([]);
  private _patient = new BehaviorSubject<any>([]);

  private _doctor = new BehaviorSubject<any>([]);
  private _doctor2 = new BehaviorSubject<any>([]);
  private _doctor3 = new BehaviorSubject<any>([]);
  private _doctor4 = new BehaviorSubject<any>([]);
  private _doctor5 = new BehaviorSubject<any>([]);
  private _doctor6 = new BehaviorSubject<any>([]);

  private _clinic = new BehaviorSubject<any>([]);
  private _clinic2 = new BehaviorSubject<any>([]);
  private _clinic3 = new BehaviorSubject<any>([]);


  @Input()
  set programId(value) { this._program_id.next(value); }
  get programId() { return this._program_id.getValue(); }

  @Input()
  set programName(value) { this._program_name.next(value); }
  get programName() { return this._program_name.getValue(); }

  @Input()
  set patientData(value) { this._patient.next(value); }
  get patientData() { return this._patient.getValue(); }

  @ViewChild('formDoctorDirective') private formDoctorDirective: NgForm;

  constructor(
    private auth: AuthProvider,
    private navCtrl: NavController,
    private dbDoctor: DoctorProvider,
    private dbPatient: PatientProvider,
    private dbClinic: ClinicProvider,
    private fb: FormBuilder,
    private alertCtrl: AlertController
  ) {
    this.createForm();

    this.auth.getCurrentUser().then(user => {
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
    });
  }

  ngOnInit()  {
    this._program_id
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Program ID on Summary: ', x)
        this.program_id = x
    });

    this._program_name
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Program Name on Summary: ', x)
        this.program_name = x
    });

    this._doctor
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      this.doctor = x;
    });

    this._doctor2
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      this.doctor2 = x;
    });

    this._doctor3
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      this.doctor3 = x;
    });

    this._clinic
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      this.clinic = x;
    });

    this._clinic2
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      this.clinic2 = x;
    });

    this._clinic3
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      this.clinic3 = x;
    });


    this._patient
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Patient on Summary: ', x)
        this.patient = x
        if (x.doctor_id) {
          this.getDoctor(x.doctor_id).valueChanges()
          .takeUntil(this.ngUnsubscribe)
          .subscribe(doc => {
            this._doctor.next(doc);
            this.doctor_specialnotes = x.doctor_specialnotes;
          });
        } else {
          this._doctor.next(of(null));
        }

        if (x.doctor_2_id) {
          this.getDoctor(x.doctor_2_id).valueChanges()
          .takeUntil(this.ngUnsubscribe)
          .subscribe(doc => {
            this._doctor2.next(doc);
            this.doctor2_specialnotes = x.doctor_2_specialnotes;
          });
        } else {
          this._doctor2.next(of(null));
        }

        if (x.doctor_3_id) {
          this.getDoctor(x.doctor_3_id).valueChanges()
          .takeUntil(this.ngUnsubscribe)
          .subscribe(doc => {
            this._doctor3.next(doc);
            this.doctor3_specialnotes = x.doctor_3_specialnotes;
          });
        } else {
          this._doctor3.next(of(null));
        }

        if (x.clinic_id) {
          this.getClinic(x.clinic_id).valueChanges()
          .takeUntil(this.ngUnsubscribe)
          .subscribe(doc => {
            this._clinic.next(doc);
          });
        } else {
          this._clinic.next(of(null));
        }

        if (x.clinic_2_id) {
          this.getClinic(x.clinic_2_id).valueChanges()
          .takeUntil(this.ngUnsubscribe)
          .subscribe(doc => {
            this._clinic2.next(doc);
          });
        } else {
          this._clinic2.next(of(null));
        }

        if (x.clinic_3_id) {
          this.getClinic(x.clinic_3_id).valueChanges()
          .takeUntil(this.ngUnsubscribe)
          .subscribe(doc => {
            this._clinic3.next(doc);
          });
        } else {
          this._clinic3.next(of(null));
        }
    });

  }

  ngOnDestroy() {
    console.log('Leave patient physician and destroy subscriptions');
    this._patient.unsubscribe();
    this._program_id.unsubscribe();
    this._program_name.unsubscribe();
    this._doctor.unsubscribe();
    this._doctor2.unsubscribe();
    this._doctor3.unsubscribe();
    this._doctor4.unsubscribe();
    this._doctor5.unsubscribe();
    this._doctor6.unsubscribe();
    this._clinic.unsubscribe();
    this._clinic2.unsubscribe();
    this._clinic3.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  createForm()  {
    this.addeditDoctorForm = this.fb.group({
      'doctor_property': [null, [Validators.required]],
      'doctor': [null, [Validators.required]],
      'notes': [null],
    });
  }

  getDoctor(doctor_id: string) {
    return this.dbDoctor.getDoctor(this.program_id, doctor_id)
  }

  getClinic(clinic_id: string) {
    return this.dbClinic.getClinic(this.program_id, clinic_id)
  }

  public handleChange($event: KeyboardEvent) {
    const searchTerm = (($event.target as HTMLInputElement).value);
    this.isLoading = true;
    if (searchTerm.length > 1)  {
      console.log('Search for: ', searchTerm);
      this.dbDoctor.searchDoctors(this.program_id, searchTerm)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(doctors => {
        this.doctors = doctors;
        this.isLoading = false;
      });
    }
  }

  getDoctorInstitution(event) {
    this.doc = { ...event.source.value };
    if (event.source.value['program/' + this.program_id + '/clinics'])  {
      this.inst = { ...event.source.value['program/' + this.program_id + '/clinics'][0] };
    } else {
      this.inst = null;
    }
    delete this.doc['program/' + this.program_id + '/clinics'];
  }

  displayFn(doctor?: any): string | undefined {
    return doctor ? doctor.last_name + ', ' + doctor.first_name : undefined;
  }

  cancel()  {
    this.panelStatus = false;
    setTimeout(() => {
      this.formDoctorDirective.resetForm();
      this.addeditDoctorForm.reset()
    }, 0);
  }

  save()  {
    let doctor = this.addeditDoctorForm.value;
    let doctor_property = doctor.doctor_property;
    let clinic_property = doctor_property.replace('doctor','clinic');
    let patientupdate = {}
    patientupdate[doctor_property + '_id'] = this.doc.id;
    patientupdate[doctor_property + '_name'] = this.doc.first_name + ' ' + this.doc.last_name;
    patientupdate[doctor_property + '_specialnotes'] = doctor.notes;
    patientupdate[doctor_property] = this.doc;

    patientupdate[clinic_property + '_id'] = this.inst.id;
    patientupdate[clinic_property + '_name'] = this.inst.name;
    patientupdate[clinic_property] = this.inst;

    if (this.patient[doctor_property]) {
      let confirm = this.alertCtrl.create({
        title: "Replace Physician",
        message: "Are you sure you want to replace the existing physician?",
        buttons: [
          {
            text: "No",
            handler: () => {
              // console.log("Don't update");
            }
          },
          {
            text: "Yes",
            handler: () => {
              this.dbPatient.updatePatient(this.program_id, this.patient.id, patientupdate, this.user).then(() => {
                this.cancel();
              });
            }
          }
        ]
      });
      confirm.present();
    } else {
      this.dbPatient.updatePatient(this.program_id, this.patient.id, patientupdate, this.user).then(() => {
        this.cancel();
      });
    }
  }

  editPhysician(doctor_id, doctor) {
    doctor.id = doctor_id;
    this.navCtrl.push(ProgramDoctorsAddPage, {'doctordata': doctor});
  }

  removePhysician(doctor_property) {
    let clinic_property = doctor_property.replace('doctor','clinic');
    let patientupdate = {}
    patientupdate[doctor_property + '_id'] = null
    patientupdate[doctor_property + '_name'] = null
    patientupdate[doctor_property + '_specialnotes'] = null;
    patientupdate[doctor_property] = null;

    patientupdate[clinic_property + '_id'] = null;
    patientupdate[clinic_property + '_name'] = null;
    patientupdate[clinic_property] = null;

    this.dbPatient.updatePatient(this.program_id, this.patient.id, patientupdate, this.user);
  }

  updateNote(doctor_property, note)  {
    let patientupdate = {}
    patientupdate[doctor_property + '_specialnotes'] = note ? note: null;

    this.dbPatient.updatePatient(this.program_id, this.patient.id, patientupdate, this.user);
  }
}



// WEBPACK FOOTER //
// ./src/components/patient-physician/patient-physician.ts